import { React, useCallback } from 'react';
// import { returnReceipt, setReceiptPrintCopy } from '../../actions/checks';
import classes from './NavFiscLogs.module.css';
import {
  Button,
  Modal,
  Table,
  Accordion,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
  Form,
  Stack
} from 'react-bootstrap';
import NavIcon from '../../../../images/logs.svg';
import Loader from '../../../../images/loader.gif';
// import SearchIcon from '../../../../images/search-icon.svg';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useFiscLogs } from './hooks/useFiscLogs';
import { formatDate } from '../../../../helpers/dataFormatter';
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import DatePickerSelect from '../../../ui/DatePickerSelect';
import fiscOpertions from "../../../../enumerates/fiscOpertions";

const NavFiscLogs = (props) => {
  const {
    fiscLogsList,
    getFiscLogs,
    modalShow,
    showLoader,
    filterDateStart,
    filterDateEnd,
    setModalShow
  } = useFiscLogs();

  return (
    <div>
      <Button
        className={`me-md-2 ${classes.button}`}
        size='sm'
        onClick={(e) => {
          e.target.parentElement.focus();
          e.target.parentElement.blur();
          setModalShow(true)
        }}
      >
        <img className={classes.nav_icon} src={NavIcon} alt='checklist' /> <div className={classes.icon_text}>Логи помилок</div>
      </Button>
      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size='xl'
          centered
          scrollable={true}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {showLoader === true && (
            <img
              className='position-absolute top-50 start-50 translate-middle'
              src={Loader}
              style={{ width: '100px' }}
              alt=''
            />
          )}
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>
              Логи помилок
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={classes.modal_body}>
            <Container>
              <Row key="filter-row">
                <Col key="date-start" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateStart}
                    onChange={(date) => {
                      getFiscLogs(date, filterDateEnd);
                    }}
                  />
                </Col>
                <Col key="date-end" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateEnd}
                    onChange={(date) => {
                      getFiscLogs(filterDateStart, date);
                    }}
                  />
                </Col>
              </Row>
            </Container>
            <Accordion className='mt-1' flush>
              {fiscLogsList &&
                fiscLogsList.length > 0 &&
                fiscLogsList.map((item) => {
                  return (
                    <Accordion.Item eventKey={'history-' + item.id} key={'history-' + item.id}>
                      <Accordion.Header className={classes.header} as='div'>
                        {`${formatDate(item.date)}, ${(fiscOpertions[item?.name]?.name ?? item?.name ?? '').toUpperCase()} ${item?.receiptId ? `, Чек №${item?.receiptId}, ${item?.receipt?.fiscalized ? 'фіскалізований' : 'НЕ фіскалізований'}` : ''}`}
                      </Accordion.Header>
                      <Accordion.Body className='p-0' style={{ marginLeft: '12px', marginRight: '8px' }}>
                        {item?.errorText ?? ''}
                        {/* <Button
                          className='ms-2 mb-2'
                          size='sm'
                          variant='outline-secondary'
                          onClick={(event) => {
                            console.log('printZReport-click');
                            printZReport(item.id, item.fisn, item.localn);
                          }}
                        >
                          Друк
                        </Button> */}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </Modal.Body>
        </Modal>
      )
      }
    </div >
  );
};

export default NavFiscLogs;
